import { Action, State, StateContext } from '@ngxs/store';
import * as actions from './puzzle-id.actions';
import { Injectable } from '@angular/core';
// @dynamic
@State<string>({
  name: 'puzzleID',
  defaults: '',
})
@Injectable()
export class PuzzleIDState {
  @Action(actions.SetPuzzleID)
  SetPuzzleID(store: StateContext<string>, action: actions.SetPuzzleID) {
    store.setState(action.payload.puzzleID);
  }

  @Action(actions.ResetPuzzleID)
  ResetPuzzleID(store: StateContext<string>) {
    store.setState('');
  }
}
